"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SettingsDescriptionTextBox = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _underscore = require("underscore");
var _FormTextbox = require("../../FormTextbox");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var SettingsDescriptionTextBox = exports.SettingsDescriptionTextBox = /*#__PURE__*/(0, _react.memo)(function (_ref) {
  var _ref$presenterDescrip = _ref.presenterDescription,
    _presenterDescription = _ref$presenterDescrip === void 0 ? '' : _ref$presenterDescrip,
    handlePresenterDescriptionChange = _ref.handlePresenterDescriptionChange,
    isDisabled = _ref.isDisabled;
  var _useState = (0, _react.useState)(_presenterDescription),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    presenterDescription = _useState2[0],
    setPresenterDescription = _useState2[1];
  var debouncedDescriptionChange = (0, _react.useMemo)(function () {
    return (0, _underscore.debounce)(function (value) {
      handlePresenterDescriptionChange(value);
    }, 300);
  }, [handlePresenterDescriptionChange]);
  var handleInputChange = function handleInputChange(value, setField) {
    var debounced = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    setField(value);
    if (debounced) {
      debouncedDescriptionChange(value);
    } else {
      handlePresenterDescriptionChange(value);
    }
  };
  var hasDescriptionExceededLimit = presenterDescription.trim().length > 80;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_FormTextbox.FormTextbox, {
    "data-testid": "title",
    id: "title",
    labelText: "Title",
    value: presenterDescription,
    onChange: function onChange(event) {
      return handleInputChange(event.target.value, setPresenterDescription);
    },
    onBlur: function onBlur(event) {
      return handleInputChange(event.target.value, setPresenterDescription, false);
    },
    disabled: isDisabled,
    hasError: hasDescriptionExceededLimit,
    errorMessage: hasDescriptionExceededLimit && "Title can't exceed 80 characters"
  }));
});